import { render } from "./Delivery_Orders.vue?vue&type=template&id=6a86293f&scoped=true"
import script from "./Delivery_Orders.vue?vue&type=script&lang=js"
export * from "./Delivery_Orders.vue?vue&type=script&lang=js"

import "./Delivery_Orders.vue?vue&type=style&index=0&id=6a86293f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a86293f"]])

export default __exports__